import styled from "styled-components";

const SectionTitleWrapper = styled.div`
  position: relative;
  z-index: 1;

  h2 {
    font-family: "Poppins";
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 25px;
    color: #FF06B7;
    margin-bottom: 15px;
    text-transform: uppercase;
    span {
      margin-left: 9px;
    }
  }

  h3 {
    font-family: "Poppins";
    font-style: normal;
    font-weight: 600;
    font-size: 40px;
    line-height: 55px;
    color: #ffffff;
    margin-bottom: 0;
    text-transform: capitalize;
  }

  @media only screen and (max-width: 1199px) {
    h2 {
      margin-bottom: 10px;
    }

    h3 {
      font-size: 36px;
      line-height: 1.35;
    }
  }

  @media only screen and (max-width: 991px) {
    h2 {
      margin-bottom: 5px;
    }

    h3 {
      font-size: 32px;
    }
  }

  @media only screen and (max-width: 767px) {
    h2 {
      font-size: 12px;
      line-height: 20px;

      span {
        height: 10px;
      }
    }

    h3 {
      font-size: 30px;
      line-height: 45px;
    }
  }

  @media only screen and (max-width: 575px) {
    h3 {
      font-size: 24px;
      line-height: 35px;
    }
  }
`;

export default SectionTitleWrapper;
